import MenuScreen from "@/features/menu/MenuScreen";

export default function Menu() {
    return <MenuScreen />;
}
